/**
 * Setting Object used by other services and components
 */
var DotSettings = (function () {
    function DotSettings() {
    }
    return DotSettings;
}());
export { DotSettings };
//# sourceMappingURL=settings.model.js.map